module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"acquirers":"Adquirentes","affiliation-add":"Cadastrar nova afiliação"},"en-US":{"acquirers":"Acquirers","affiliation-add":"Create new affiliation"}}')
  delete Component.options._Ctor
}
